/*
  OZ 2026-10-16: behaviour of our own collection and search page (snippets/oz-plp.liquid). Liquid draws the final page;
  this only reacts to the shopper:
  - the filter sheet (under 1000px): open, close (shade, Show button, Escape), body scroll lock;
  - a filter change, chip, Clear all or sort: fetch the same URL through the Section Rendering API
    (?section_id=<id>), swap the parts marked data-oz-plp-part, push the URL (Back works: popstate re-renders);
  - "Show more (N)" in a filter group; "Show more" under the grid (variant cards: the next 24 from the <template>,
    then the next product page; product cards: the next page), and the description's "Read more".
*/
(function () {
  'use strict';

  var root = document.querySelector('[data-oz-plp]');
  if (!root) return;

  var sectionId = root.getAttribute('data-section-id');
  var openGroups = {};          // groups the shopper expanded, kept across re-renders
  var ctrl = null;              // the request in flight

  function q(sel, el) { return (el || root).querySelector(sel); }
  function qa(sel, el) { return Array.prototype.slice.call((el || root).querySelectorAll(sel)); }
  function isSheet() { return window.matchMedia('(max-width: 999px)').matches; }

  /* ---------- sheet ---------- */
  function openSheet() {
    root.classList.add('is-sheet-open');
    document.documentElement.classList.add('oz-plp-lock');
    var head = q('.oz-plp-f__head a');
    if (head) head.focus({ preventScroll: true });
  }
  function closeSheet() {
    if (!root.classList.contains('is-sheet-open')) return;
    root.classList.remove('is-sheet-open');
    document.documentElement.classList.remove('oz-plp-lock');
    var btn = q('[data-oz-plp-open]');
    if (btn) btn.focus({ preventScroll: true });
  }

  /* ---------- URL from the form ---------- */
  function formUrl() {
    var form = q('[data-oz-plp-form]');
    var params = new URLSearchParams();
    var defSort = root.getAttribute('data-sort-default');
    new FormData(form).forEach(function (value, key) {
      if (value === '') return;
      if (key === 'sort_by' && value === defSort) return;   // the default sort stays out of the URL
      params.append(key, value);
    });
    var action = form.getAttribute('action') || window.location.pathname;
    var s = params.toString();
    return action + (s ? '?' + s : '');
  }

  function canon(url) {
    var u = new URL(url, window.location.origin);
    var defSort = root.getAttribute('data-sort-default');
    var pairs = [];
    u.searchParams.forEach(function (v, k) {
      if (k === 'section_id' || k === 'page' || (k === 'sort_by' && v === defSort)) return;
      pairs.push(k + '=' + v);
    });
    return u.pathname + '?' + pairs.sort().join('&');
  }

  function withSection(url) {
    var u = new URL(url, window.location.origin);
    u.searchParams.set('section_id', sectionId);
    return u.toString();
  }

  /* ---------- render ---------- */
  function swap(html) {
    var doc = new DOMParser().parseFromString(html, 'text/html');
    var fresh = doc.querySelector('[data-oz-plp]');
    if (!fresh) return false;
    var body = q('.oz-plp-f__body');
    var scroll = body ? body.scrollTop : 0;
    var active = document.activeElement;
    var activeName = active && active.name ? active.name : null;
    var activeValue = active && active.value;

    qa('[data-oz-plp-part]').forEach(function (part) {
      var name = part.getAttribute('data-oz-plp-part');
      var next = fresh.querySelector('[data-oz-plp-part="' + name + '"]');
      if (next) part.replaceWith(next);
    });
    var hidden = q('[data-oz-plp-form] input[name="sort_by"]');
    var freshSort = fresh.querySelector('[data-oz-plp-form] input[name="sort_by"]');
    if (hidden && freshSort) hidden.value = freshSort.value;
    var clear = q('.oz-plp-f__head a');
    var freshClear = fresh.querySelector('.oz-plp-f__head a');
    if (clear && freshClear) clear.setAttribute('href', freshClear.getAttribute('href'));

    Object.keys(openGroups).forEach(function (gid) {
      var g = q('[data-oz-plp-g="' + gid + '"]');
      if (g) setGroup(g, openGroups[gid]);
    });
    body = q('.oz-plp-f__body');
    if (body) body.scrollTop = scroll;
    if (activeName) {
      var again = qa('[name="' + activeName.replace(/"/g, '\\"') + '"]').filter(function (el) { return el.value === activeValue; })[0];
      if (again) again.focus({ preventScroll: true });
    }
    return true;
  }

  function load(url, push) {
    if (ctrl) ctrl.abort();
    ctrl = typeof AbortController !== 'undefined' ? new AbortController() : null;
    root.classList.add('is-loading');
    fetch(withSection(url), { credentials: 'same-origin', signal: ctrl ? ctrl.signal : undefined })
      .then(function (r) { if (!r.ok) throw new Error('HTTP ' + r.status); return r.text(); })
      .then(function (html) {
        if (!swap(html)) { window.location.href = url; return; }
        if (push === 'replace') window.history.replaceState({ ozPlp: true }, '', url);
        else if (push) window.history.pushState({ ozPlp: true }, '', url);
        if (window.ozPlpRefresh) window.ozPlpRefresh();
        if (window.ozPlpFloor) window.ozPlpFloor();
        root.classList.remove('is-loading');
        if (!isSheet()) {
          var top = root.querySelector('.oz-plp__wrap').getBoundingClientRect().top;
          if (top < 0) window.scrollBy({ top: top - 16, behavior: 'smooth' });
        }
      })
      .catch(function (e) {
        if (e && e.name === 'AbortError') return;
        window.location.href = url;
      });
  }

  /* ---------- groups ---------- */
  function setGroup(g, open) {
    g.classList.toggle('is-open', open);
    var b = g.querySelector('[data-oz-plp-more]');
    if (b) {
      b.textContent = open ? b.getAttribute('data-less') : b.getAttribute('data-more');
      b.setAttribute('aria-expanded', open ? 'true' : 'false');
    }
  }

  /* ---------- Show more (cards) ---------- */
  function moreText(btn, left) {
    var small = btn.querySelector('small');
    var one = btn.getAttribute('data-one');
    var many = btn.getAttribute('data-many');
    btn.setAttribute('data-left', left);
    if (small) small.textContent = left > 0 ? left + ' more ' + (left === 1 ? one : many) : 'More ' + many;
  }

  function showMore(btn) {
    var grid = q('[data-oz-plp-grid]');
    var step = parseInt(btn.getAttribute('data-step'), 10) || 24;
    var rest = q('template[data-oz-plp-rest]');
    if (rest && rest.content.children.length) {
      var frag = document.createDocumentFragment();
      for (var i = 0; i < step && rest.content.firstElementChild; i++) frag.appendChild(rest.content.firstElementChild);
      grid.appendChild(frag);
      var left = rest.content.children.length;
      if (left) { moreText(btn, left); return; }
      rest.remove();
      if (!btn.hasAttribute('data-next')) { btn.remove(); return; }
      moreText(btn, 0);
      return;
    }
    var next = btn.getAttribute('data-next');
    if (!next) { btn.remove(); return; }
    btn.classList.add('is-busy');
    fetch(withSection(next), { credentials: 'same-origin' })
      .then(function (r) { if (!r.ok) throw new Error('HTTP ' + r.status); return r.text(); })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var cards = doc.querySelectorAll('[data-oz-plp-grid] > .product-item');
        var frag = document.createDocumentFragment();
        Array.prototype.forEach.call(cards, function (c) { frag.appendChild(c); });
        grid.appendChild(frag);
        var freshRest = doc.querySelector('template[data-oz-plp-rest]');
        if (freshRest) grid.insertAdjacentElement('afterend', freshRest);
        var freshBtn = doc.querySelector('[data-oz-plp-showmore]');
        if (freshBtn) {
          if (btn.hasAttribute('data-variants')) {
            // variant cards: the total counts this page only; add what is still waiting here
            var waiting = freshRest ? freshRest.content.children.length : 0;
            moreText(btn, waiting);
          } else {
            moreText(btn, parseInt(freshBtn.getAttribute('data-left'), 10) || 0);
          }
          if (freshBtn.hasAttribute('data-next')) {
            btn.setAttribute('data-next', freshBtn.getAttribute('data-next'));
            btn.setAttribute('href', freshBtn.getAttribute('data-next'));
          } else {
            btn.removeAttribute('data-next');
            if (!freshRest) btn.remove();
          }
        } else {
          btn.remove();
        }
        btn.classList.remove('is-busy');
      })
      .catch(function () { window.location.href = next; });
  }

  /* ---------- events ---------- */
  root.addEventListener('click', function (e) {
    var t = e.target;
    if (t.closest('[data-oz-plp-open]')) { e.preventDefault(); openSheet(); return; }

    var more = t.closest('[data-oz-plp-more]');
    if (more) {
      var g = more.closest('[data-oz-plp-g]');
      var open = !g.classList.contains('is-open');
      openGroups[g.getAttribute('data-oz-plp-g')] = open;
      setGroup(g, open);
      return;
    }

    var sm = t.closest('[data-oz-plp-showmore]');
    if (sm) { e.preventDefault(); if (!sm.classList.contains('is-busy')) showMore(sm); return; }

    var nav = t.closest('a[data-oz-plp-nav]');
    if (nav) { e.preventDefault(); load(nav.getAttribute('href'), true); return; }

    if (t.closest('[data-oz-plp-close]')) {
      e.preventDefault();
      applyAndClose();
      return;
    }

    var dm = t.closest('[data-oz-plp-desc-more]');
    if (dm) {
      var d = q('[data-oz-plp-desc]');
      var on = !d.classList.contains('is-open');
      d.classList.toggle('is-open', on);
      dm.textContent = on ? 'Read less' : 'Read more';
      dm.setAttribute('aria-expanded', on ? 'true' : 'false');
    }
  });

  root.addEventListener('change', function (e) {
    var t = e.target;
    if (t.matches('[data-oz-plp-sort]')) {
      var hidden = q('[data-oz-plp-form] input[name="sort_by"]');
      hidden.value = t.value;
      load(formUrl(), true);
      return;
    }
    if (t.closest('[data-oz-plp-form]')) {
      if (t.matches('[data-oz-plp-price]')) {
        var v = t.value.trim();
        if (v !== '' && !/^\d+(\.\d+)?$/.test(v)) return;
      }
      load(formUrl(), true);
    }
  });

  // Every change is applied as it happens; the green button (and Enter in a price box) applies anything still
  // pending, such as a price typed but not yet committed, then closes the sheet.
  function applyAndClose() {
    var url = formUrl();
    if (canon(url) !== canon(window.location.href)) load(url, true);
    closeSheet();
  }
  root.addEventListener('submit', function (e) {
    if (!e.target.matches('[data-oz-plp-form]')) return;
    e.preventDefault();
    applyAndClose();
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') closeSheet();
  });

  window.addEventListener('popstate', function () {
    load(window.location.href, false);
  });

  // the pager's way to another server page (?page=N): how is true (push the URL), 'replace' or false
  window.ozPlpGo = function (url, how) { load(url, how); };

  // the sheet closes itself if the window grows into the sidebar layout
  window.matchMedia('(max-width: 999px)').addEventListener('change', function (m) { if (!m.matches) closeSheet(); });
})();

/* 2026-10-16: the desktop Sort menu is drawn by us (the browser's own option list can't be styled); the <select>
   stays underneath for keyboards, phones (their native picker) and no-JavaScript visits, and our menu only sets its
   value and fires its change, so sorting runs through the same code. */
(function () {
  var open = null;
  function close() {
    if (!open) return;
    open.menu.remove();
    open.label.classList.remove('is-open');
    open = null;
  }
  document.addEventListener('mousedown', function (e) {
    var sel = e.target.closest && e.target.closest('.oz-plp__sel select');
    if (!sel) {
      if (open && !open.menu.contains(e.target)) close();
      return;
    }
    if (window.innerWidth < 1000) return;
    e.preventDefault();
    if (open) { close(); return; }
    var label = sel.closest('.oz-plp__sel');
    var menu = document.createElement('div');
    menu.className = 'oz-plp-menu';
    menu.setAttribute('role', 'listbox');
    Array.prototype.forEach.call(sel.options, function (o) {
      var b = document.createElement('button');
      b.type = 'button';
      b.className = 'oz-plp-menu__opt' + (o.selected ? ' is-on' : '');
      b.setAttribute('role', 'option');
      b.setAttribute('aria-selected', o.selected ? 'true' : 'false');
      b.textContent = o.textContent;
      b.addEventListener('click', function () {
        close();
        if (sel.value === o.value) return;
        sel.value = o.value;
        sel.dispatchEvent(new Event('change', { bubbles: true }));
      });
      menu.appendChild(b);
    });
    label.appendChild(menu);
    label.classList.add('is-open');
    open = { menu: menu, label: label };
  });
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape') close(); });
})();


/* 2026-10-16: the price slider (two handles writing the price boxes, applied on release through the boxes' own
   change) and the page numbers (every card of a server page is in the page; 24 show at a time, ?vp=N in the URL).
   2026-10-17, one pager: Shopify serves 250 products a server page (?page=N) and the add-ons and sold-out ones are
   left out after that, so a server page holds 0 to 250 cards. When there are several, every other server page's
   card count is read from sections/oz-plp-count.liquid (the same URL with section_id=oz-plp-count, kept for ten
   minutes in sessionStorage) and the numbers run as ONE sequence of pages of 24 across them all; a number on another
   server page loads ?page=S&vp=N in place, and the count's "N+" (Liquid sees one server page) becomes the exact total. Until the counts are in (the pager sits under 24 cards), nothing is drawn;
   if one cannot be read, this server page's numbers show, with the arrows stepping to the next or previous one. */
(function () {
  function paintRange(r) {
    var lo = r.querySelector('[data-oz-plp-range-lo]'), hi = r.querySelector('[data-oz-plp-range-hi]');
    var min = Number(r.getAttribute('data-min')) || 0, max = Number(r.getAttribute('data-max')) || 1, span = Math.max(1, max - min);
    var fill = r.querySelector('[data-oz-plp-range-fill]');
    fill.style.left = ((Number(lo.value) - min) / span * 100) + '%';
    fill.style.right = (100 - (Number(hi.value) - min) / span * 100) + '%';
  }
  function boxes(r) {
    var g = r.closest('.oz-plp-g') || r.parentNode;
    var b = g.querySelectorAll('[data-oz-plp-price]');
    return { lo: b[0], hi: b[1] };
  }
  document.addEventListener('input', function (e) {
    var t = e.target, r = t.closest && t.closest('[data-oz-plp-range]');
    if (!r) return;
    var lo = r.querySelector('[data-oz-plp-range-lo]'), hi = r.querySelector('[data-oz-plp-range-hi]');
    if (Number(lo.value) > Number(hi.value)) { if (t === lo) lo.value = hi.value; else hi.value = lo.value; }
    var bx = boxes(r);
    var max = Number(r.getAttribute('data-max')) || 0;
    var floor = Number(r.getAttribute('data-min')) || 0;
    if (bx.lo) bx.lo.value = Number(lo.value) > floor ? lo.value : '';
    if (bx.hi) bx.hi.value = Number(hi.value) < max ? hi.value : '';
    paintRange(r);
  });
  document.addEventListener('change', function (e) {
    var t = e.target, r = t.closest && t.closest('[data-oz-plp-range]');
    if (!r) return;
    var bx = boxes(r), box = t.matches('[data-oz-plp-range-lo]') ? bx.lo : bx.hi;
    if (box) box.dispatchEvent(new Event('change', { bubbles: true }));
  });

  var TTL = 10 * 60 * 1000;
  function pageOf() {
    var m = /[?&]vp=(\d+)/.exec(window.location.search);
    return m ? Math.max(1, Number(m[1])) : 1;
  }
  function setUrl(page, replace) {
    var u = new URL(window.location.href);
    if (page > 1) u.searchParams.set('vp', String(page)); else u.searchParams.delete('vp');
    window.history[replace ? 'replaceState' : 'pushState']({ ozPlp: true }, '', u.pathname + u.search);
  }
  // the URL of server page s (its first card page v), keeping the filters, sort and search terms
  function serverUrl(s, v) {
    var u = new URL(window.location.href);
    u.searchParams.delete('section_id');
    if (s > 1) u.searchParams.set('page', String(s)); else u.searchParams.delete('page');
    if (v > 1) u.searchParams.set('vp', String(v)); else u.searchParams.delete('vp');
    return u.pathname + u.search;
  }
  // the filters, sort and terms of this URL, without the page: one key for every server page's count
  function listKey() {
    var u = new URL(window.location.href), pairs = [];
    u.searchParams.forEach(function (v, k) { if (k !== 'page' && k !== 'vp' && k !== 'section_id') pairs.push(k + '=' + v); });
    return 'ozPlpN:' + u.pathname + '?' + pairs.sort().join('&');
  }
  function readCache(key) {
    try { var c = JSON.parse(sessionStorage.getItem(key) || 'null'); if (c && Date.now() - c.t < TTL) return c.n; } catch (e) {}
    return null;
  }
  function writeCache(key, n) {
    try { sessionStorage.setItem(key, JSON.stringify({ t: Date.now(), n: n })); } catch (e) {}
  }
  // card counts of every server page: { 1: 34, 2: 51, ... }, or null when one cannot be read
  var pending = {};
  function serverCounts(spages, here, nHere) {
    var key = listKey();
    if (pending[key]) return pending[key];
    var counts = readCache(key) || {};
    counts[here] = nHere;
    var jobs = [];
    for (var s = 1; s <= spages; s++) {
      if (typeof counts[s] === 'number') continue;
      jobs.push((function (s) {
        var u = new URL(serverUrl(s, 1), window.location.origin);
        u.searchParams.set('section_id', 'oz-plp-count');
        return fetch(u.toString(), { credentials: 'same-origin' })
          .then(function (r) { if (!r.ok) throw new Error('HTTP ' + r.status); return r.text(); })
          .then(function (html) {
            var m = /data-oz-plp-n="(\d+)"/.exec(html);
            if (!m) throw new Error('no count');
            counts[s] = Number(m[1]);
          });
      })(s));
    }
    var p = Promise.all(jobs).then(function () { writeCache(key, counts); return counts; }, function () { return null; });
    pending[key] = p;
    p.then(function () { delete pending[key]; });
    return p;
  }
  function draw(nav, cur, last, at) {
    // at(n) -> [server page, card page] of number n; the shown numbers: first, last and the two beside the current
    var parts = [];
    for (var n = 1; n <= last; n++) {
      if (n === 1 || n === last || Math.abs(n - cur) <= 1) parts.push(n);
      else if (parts[parts.length - 1] !== 0) parts.push(0);
    }
    function btn(n, label, aria) {
      var t = at(n);
      return '<button type="button" class="oz-plp-pager__btn" data-go-s="' + t[0] + '" data-go-v="' + t[1] + '"' + (aria ? ' aria-label="' + aria + '"' : '') + '>' + label + '</button>';
    }
    var html = '';
    if (cur > 1) html += btn(cur - 1, '&lsaquo;', 'Previous page');
    parts.forEach(function (n) {
      if (n === 0) html += '<span class="oz-plp-pager__gap">&hellip;</span>';
      else if (n === cur) html += '<span class="oz-plp-pager__btn is-on" aria-current="page">' + n + '</span>';
      else html += btn(n, String(n));
    });
    if (cur < last) html += btn(cur + 1, '&rsaquo;', 'Next page');
    nav.innerHTML = html;
  }
  function pager() {
    var nav = document.querySelector('[data-oz-plp-pager]');
    if (!nav) return;
    var grid = document.querySelector('[data-oz-plp-grid]');
    var size = Number(nav.getAttribute('data-size')) || 24;
    var here = Number(nav.getAttribute('data-spage')) || 1;
    var spages = Number(nav.getAttribute('data-spages')) || 1;
    var cards = grid ? Array.prototype.slice.call(grid.children) : [];
    var pages = Math.max(1, Math.ceil(cards.length / size));
    var want = pageOf();
    var cur = Math.min(want, pages);
    if (want !== cur) setUrl(cur, true);
    cards.forEach(function (c, i) { c.hidden = i < (cur - 1) * size || i >= cur * size; });
    if (window.lazySizes && window.lazySizes.loader) {
      cards.forEach(function (c) { if (!c.hidden) c.querySelectorAll('.lazyload').forEach(function (img) { window.lazySizes.loader.unveil(img); }); });
    }
    nav.__ozHere = here;
    if (spages <= 1) {
      if (pages > 1) draw(nav, cur, pages, function (n) { return [here, n]; });
      else nav.innerHTML = '';
      return;
    }
    nav.innerHTML = '';
    serverCounts(spages, here, cards.length).then(function (counts) {
      if (nav !== document.querySelector('[data-oz-plp-pager]')) return;   // re-rendered meanwhile
      if (!counts) {
        // a count could not be read: this server page's numbers, the arrows step to the next or previous server page
        draw(nav, cur, pages, function (n) { return [here, n]; });
        if (cur === 1 && here > 1) nav.insertAdjacentHTML('afterbegin', '<button type="button" class="oz-plp-pager__btn" data-go-s="' + (here - 1) + '" data-go-v="9999" aria-label="Previous page">&lsaquo;</button>');
        if (cur === pages && here < spages) nav.insertAdjacentHTML('beforeend', '<button type="button" class="oz-plp-pager__btn" data-go-s="' + (here + 1) + '" data-go-v="1" aria-label="Next page">&rsaquo;</button>');
        return;
      }
      var first = [], total = 0, cardsAll = 0;
      for (var s = 1; s <= spages; s++) {
        first[s] = total;
        total += Math.ceil((counts[s] || 0) / size);
        cardsAll += counts[s] || 0;
      }
      // the count Liquid could only give as "N+" (it sees one server page) becomes the exact number of cards
      document.querySelectorAll('[data-oz-plp] .oz-plp__count, [data-oz-plp] [data-oz-plp-part="show"]').forEach(function (el) {
        if (/\d[\d,]*\+/.test(el.textContent)) el.textContent = el.textContent.replace(/\d[\d,]*\+/, cardsAll.toLocaleString('en-AU'));
      });
      if (!cards.length) {
        // this server page has no cards: on to the nearest one that has
        var to = 0;
        for (var a = here + 1; a <= spages && !to; a++) if (counts[a] > 0) to = a;
        for (var b = here - 1; b >= 1 && !to; b--) if (counts[b] > 0) to = b;
        if (to && window.ozPlpGo) window.ozPlpGo(serverUrl(to, to > here ? 1 : 9999), 'replace');
        return;
      }
      draw(nav, first[here] + cur, total, function (n) {
        for (var s = spages; s >= 1; s--) if (counts[s] > 0 && n > first[s]) return [s, n - first[s]];
        return [here, n];
      });
    });
  }
  function refresh() {
    document.querySelectorAll('[data-oz-plp-range]').forEach(paintRange);
    pager();
  }
  window.ozPlpRefresh = refresh;
  document.addEventListener('click', function (e) {
    var b = e.target.closest && e.target.closest('[data-oz-plp-pager] [data-go-s]');
    if (!b) return;
    var nav = b.closest('[data-oz-plp-pager]');
    var s = Number(b.getAttribute('data-go-s')), v = Number(b.getAttribute('data-go-v'));
    if (s === nav.__ozHere) {
      setUrl(v);
      pager();
    } else if (window.ozPlpGo) {
      window.ozPlpGo(serverUrl(s, v), true);
    } else {
      window.location.href = serverUrl(s, v);
      return;
    }
    var main = document.querySelector('.oz-plp__main');
    if (main) window.scrollBy({ top: main.getBoundingClientRect().top - 16, behavior: 'smooth' });
  });
  window.addEventListener('popstate', function () { setTimeout(pager, 0); });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', refresh); else refresh();
})();

/* 2026-10-16: the price slider's floor is the cheapest in-stock price of the WHOLE collection, not of the products a
   filter leaves (Dereck: "why minimum keeps floating"). Read once from the collection's public products.json, kept for
   the session, and applied to the slider, its labels and the lowest-price placeholder after every render. */
(function () {
  function floorFor(url) {
    var key = 'ozPlpFloor2:' + url;
    try { var v = sessionStorage.getItem(key); if (v) return Promise.resolve(Number(v)); } catch (e) {}
    return fetch(url.replace(/\/$/, '') + '/products.json?limit=250', { credentials: 'same-origin' })
      .then(function (r) { return r.ok ? r.json() : { products: [] }; })
      .then(function (d) {
        var min = Infinity;
        // the add-ons are never cards (snippets/oz-plp.liquid), so their prices never set the floor
        var addon = /^(warranty|installation|service)$/i;
        (d.products || []).forEach(function (p) {
          if (addon.test(p.product_type || '')) return;
          (p.variants || []).forEach(function (v) { if (v.available && Number(v.price) < min) min = Number(v.price); });
        });
        if (!isFinite(min)) return null;
        min = Math.floor(min);
        try { sessionStorage.setItem(key, String(min)); } catch (e) {}
        return min;
      })
      .catch(function () { return null; });
  }
  function apply() {
    var root = document.querySelector('[data-oz-plp][data-floor-url]');
    var r = document.querySelector('[data-oz-plp-range]');
    if (!root || !r) return;
    floorFor(root.getAttribute('data-floor-url')).then(function (min) {
      if (min == null) return;
      var lo = r.querySelector('[data-oz-plp-range-lo]'), hi = r.querySelector('[data-oz-plp-range-hi]');
      var was = Number(r.getAttribute('data-min'));
      r.setAttribute('data-min', String(min));
      lo.min = hi.min = String(min);
      if (Number(lo.value) === was || Number(lo.value) < min) lo.value = String(Math.max(min, Number(lo.value) === was ? min : Number(lo.value)));
      var ends = r.parentNode.querySelector('.oz-plp-range__ends span');
      if (ends) ends.textContent = '$' + min.toLocaleString('en-AU');
      var box = (r.closest('.oz-plp-g') || r.parentNode).querySelector('[data-oz-plp-price]');
      if (box) box.placeholder = String(min);
      if (window.ozPlpRefresh) window.ozPlpRefresh();
    });
  }
  var prev = window.ozPlpRefresh;
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', apply); else apply();
  document.addEventListener('oz:plp:rendered', apply);
  window.ozPlpFloor = apply;
})();

/* 2026-10-16: a variant card's Add to cart (Dereck: "should be Add to cart... and it needs to trigger the pop-up").
   The card's form holds the variant; the product's "Complete your order" pop-up is fetched for that product and
   variant (sections/oz-upsells-popup-card.liquid renders the product page's own snippet), handed to the card the way
   the product page hands its section the pop-up (section.__ozUpPopup), and the same OzBuy.buy('cart') runs: pop-up
   first when the product has one, then the cart. Any failure posts the form, so the variant always goes in. */
(function () {
  var inflight = false;
  document.addEventListener('click', function (e) {
    var btn = e.target.closest && e.target.closest('[data-oz-plp-buy]');
    if (!btn || inflight) return;
    var form = btn.closest('form');
    var card = btn.closest('.product-item') || form;
    if (!window.OzBuy || !window.OzBuy.buy || !form) return; // the form posts on its own
    e.preventDefault();
    inflight = true;
    btn.setAttribute('aria-busy', 'true');
    var done = function () { inflight = false; btn.removeAttribute('aria-busy'); };
    var url = '/products/' + encodeURIComponent(btn.getAttribute('data-handle')) + '?variant=' + btn.getAttribute('data-variant') + '&section_id=oz-upsells-popup-card';
    fetch(url, { credentials: 'same-origin' })
      .then(function (r) { return r.ok ? r.text() : ''; })
      .catch(function () { return ''; })
      .then(function (html) {
        if (card.__ozUpPopup && card.__ozUpPopup.parentNode) card.__ozUpPopup.parentNode.removeChild(card.__ozUpPopup);
        card.__ozUpPopup = null;
        var tmp = document.createElement('div');
        tmp.innerHTML = html;
        var root = tmp.querySelector('[data-oz-upsells-popup]');
        if (root) {
          document.body.appendChild(root);
          card.__ozUpPopup = root;
        }
        return window.OzBuy.buy('cart', { section: card, button: btn });
      })
      .then(function (navigated) { done(); if (navigated === false && !card.__ozUpPopup) form.submit(); },
            function () { done(); form.submit(); });
  });
})();
